import { render, staticRenderFns } from "./oilGunIndex.vue?vue&type=template&id=76160714&scoped=true"
import script from "./oilGunIndex.vue?vue&type=script&lang=js"
export * from "./oilGunIndex.vue?vue&type=script&lang=js"
import style0 from "./oilGunIndex.vue?vue&type=style&index=0&id=76160714&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76160714",
  null
  
)

export default component.exports